import { ITheme } from "contexts/ThemeContext";
import { StyleSheet, ViewStyle } from "react-native";

export default (props: ITheme) => StyleSheet.create({
    container: {

    },
    reaction: {
        fontSize: 20,
    }
})